import alertBox from '@/components/generics/alert-box/alert-box.vue';
import { mapActions, mapGetters } from 'vuex';
import { isDebugOn } from '@/logger';
import { isMethodFeeWaived } from '@/components/wallet/shared/depositMethodTypes';

export default {
  components: {
    alertBox,
  },
  props: {
    instantCreditData: {},
  },
  data() {
    return {
      promoCodeDetail: {},
      promotionalCreditAmount: 0,
      instantCreditDetail: this.instantCreditData || {},
      promoInit: true,
      promoAmount: 0,
      promoApplying: false,
      promoApplied: false,
      promoAppliedCode: '',
      promoHasError: false,
    };
  },
  computed: {
    ...mapGetters('wallet', ['depositMethodByType']),
    method() {
      return this.depositMethodByType(this.depositMethodType) || {};
    },
    showInstantCreditNotification() {
      return this.instantCreditDetail && typeof this.instantCreditDetail.success !== 'undefined' && !this.promoApplied;
    },
    instantCreditBoxLevel() {
      return this.instantCreditDetail.success ? 'success' : 'warning';
    },
    instantCreditBoxMessage() {
      return this.instantCreditDetail.success
        ? this.instantCreditDetail.friendlyDescription
        : this.instantCreditDetail.errorMessage;
    },
    showPromoNotification() {
      return this.promoCodeDetail && this.promoCodeDetail.showPromoCodeBox;
    },
    isFeeWaived() {
      return isMethodFeeWaived(this.method);
    },
    feeStateBannerTxt() {
      return this.method.feeStateBannerTxt || '';
    },
    disclaimer() {
      return this.method.disclaimerMsg || '';
    },
    timeframeMsg() {
      return this.method.timeframeMsg || '';
    },
    noFeeMessagePrefix() {
      return this.timeframeMsg ? `${this.timeframeMsg} • ` : '';
    },
    feeCap() {
      return this.method.feeCap;
    },
    promoBonus() {
      if (this.promoApplied) {
        return Number(this.promoAmount).toFixed(2);
      }
      return '0.00';
    },
    notificationPayload() {
      const items = [];
      if (this.showPromoNotification) {
        items.push({ key: 'promo', text: this.promoCodeDetail.friendlyDescription, level: 'success' });
      }
      if (this.showInstantCreditNotification) {
        items.push({ key: 'instant-credit', text: this.instantCreditBoxMessage, level: this.instantCreditBoxLevel });
      }
      return items;
    },
  },
  watch: {
    notificationPayload: {
      immediate: true,
      handler(items) {
        this.$emit('notification', items);
      },
    },
  },
  methods: {
    ...mapActions('wallet', ['submitInstantCredit']),
    onInitialisedPromoCode() {
      this.promoInit = false;
    },
    onApplyPromoCode(code) {
      this.promoApplying = true;
      this.promoHasError = false;
      if (isDebugOn() && code === 'DEBUG_LOCAL') {
        this.promoApplied = true;
        this.promoAppliedCode = code;
        this.promoHasError = false;
        this.promoAmount = 13;
        this.promoApplying = false;
      } else {
        this.submitInstantCredit(code)
          .then((data) => {
            this.promoApplying = false;
            if (data && data.success) {
              this.promoApplied = true;
              this.promoAppliedCode = code;
              this.promoHasError = false;
              this.promoAmount = data.amount;
            } else {
              this.promoHasError = true;
            }
          })
          .catch(() => {
            this.promoApplying = false;
            this.promoHasError = true;
            this.instantCreditDetail = { success: false };
          });
      }
    },
    onResetPromoCode() {
      this.instantCreditDetail = this.instantCreditData || {};
      this.promoApplied = false;
      this.promoAppliedCode = '';
      this.promoHasError = false;
      this.promoApplying = false;
      this.promoInit = true;
    },
    onRemovePromoCode() {
      this.promoApplied = false;
      this.promoAppliedCode = '';
      this.promoHasError = false;
      this.instantCreditDetail = this.instantCreditData || {};
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/promoCode.js